import { InfoBox, StyledText } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { useQuery } from '@tanstack/react-query'
import AlertIcon from 'mdi-react/AlertIcon'
import { useNavigate } from 'react-router-dom'

import queries from '@/api/queries'
import Page from '@/components/page/Page'
import { useCart } from '@/contexts/cart/cart-context'
import useUser from '@/hooks/user'
import { ecomPolicyResources } from '@/resources/ecom-policy'
import { APP_ROUTES } from '@/util/appRoutes'
import { isEcomMigrationOrder, isEcomOrderOpen } from '@/util/misc'

import { Translation } from '../i18n/Translation'

import { OrderList } from './orders/OrderList'
import PolicyList from './PolicyList'

export const EcomPolicyShop = () => {
  const { data, isLoading } = useQuery(queries.policyList(), ecomPolicyResources.getList)
  const user = useUser()
  const navigate = useNavigate()
  const { items } = useCart()

  const policyList = data?.policyList
  let orders = data?.orders
  if (orders) {
    orders = orders?.filter(({ status }) => !isEcomMigrationOrder(status))
  }

  const greenpoolOrders = data?.greenpoolOrders

  const openOrders = orders?.filter(({ status }) => isEcomOrderOpen(status))
  const hasOpenOrders = openOrders ? openOrders.length > 0 : false
  const invalidFields = !user?.email || !user?.code
  const invalidCostObjectTransaltionId = invalidFields
    ? `cost-object-missing${!user?.email ? '-email' : ''}${!user?.code ? '-phone' : ''}`
    : null
  const hasGreenpoolOrders = greenpoolOrders && greenpoolOrders.length > 0
  const hasMoreThenOneOpenOrder = orders && (hasOpenOrders ? orders.length > 1 : orders.length > 0)
  const hasAllOrders = hasMoreThenOneOpenOrder || hasGreenpoolOrders

  const itemsCount = items.filter(item => !item.product?.isMandatory).length

  return (
    <Page pageWrapperClassName="max-w-5xl">
      <h2 className="!m-0">
        <StyledText
          colorMode="black"
          fontWeight="bold"
          size="xl"
          className="hidden text-center md:block"
        >
          <Translation id="Kjøp av utstyr" />
        </StyledText>
      </h2>

      {hasOpenOrders && <OrderList isOnlyOpenOrdersVisible className="my-2" />}

      <div className="mobile:flex-row mobile:gap-4 mb-2 flex flex-col-reverse justify-between gap-2 sm:mt-4 md:mb-2 md:mt-6">
        {hasAllOrders && (
          <Button
            className="mobile:w-auto m-0 w-full"
            variant="secondary"
            onClick={() => {
              navigate(APP_ROUTES.ecomPolicyOrderList)
            }}
          >
            <Translation id="Se alle ordre" />
          </Button>
        )}
      </div>

      <h3 className="!m-0 !mb-2 text-left sm:!mb-4 sm:text-center md:!mb-6">
        <StyledText noMargin colorMode="black" fontWeight="bold" size="large">
          <Translation id="Dine profiler" />
        </StyledText>
      </h3>

      {invalidFields && (
        <InfoBox emphasis="warning" marginBottom={4}>
          <AlertIcon />
          <Translation id={invalidCostObjectTransaltionId ?? ''} />
        </InfoBox>
      )}

      {!invalidFields && (
        <>
          <PolicyList isLoading={isLoading} policyList={policyList} />

          {itemsCount > 0 && policyList && policyList.length > 0 && (
            <div className="mt-6 flex w-full items-center justify-center">
              <Button
                className="mobile:w-auto m-0 w-full"
                variant="primary"
                onClick={() => {
                  navigate(APP_ROUTES.cart)
                }}
              >
                <Translation id="Proceed to checkout" />
              </Button>
            </div>
          )}
        </>
      )}
    </Page>
  )
}
